import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { ClienteResumo } from 'src/app/admihair/api/dto/cliente-resumo';
import { Orcamento } from 'src/app/admihair/api/dto/orcamento';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { AdmihairBaseComponent } from 'src/app/admihair/components/admihair-base.component';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { OrcamentoService } from 'src/app/admihair/service/orcamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-central-cliente-pacote-listar',
  templateUrl: './central-cliente-pacote-listar.component.html',
  styleUrls: ['./central-cliente-pacote-listar.component.scss']
})
export class CentralClientePacoteListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  listaPacotes: Orcamento[] = [];
  clientesComPacote: ClienteResumo[] = [];
  clienteSelecionado: ClienteResumo = {nome: 'TODOS'};
  loading: boolean = true;
  listaStatusPacote: string[] = [
    'TODOS', 'ABERTO',
    'PAGO', 'RESGATADO',
    'FINALIZADO', 'VENCIDO'];
  statusPacoteSelecionado: string = 'TODOS';


  itensPaginados?: Paginador<Orcamento>;
  numeroPagina: number = 0;
  inputBusca?: string = '';
  ordenacao: string = 'dataOrcamento,DESC';
  tamanhoPagina: number = 10;

  constructor(private orcamentoService: OrcamentoService,
    public clienteService: ClienteService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.listarClientesComPacote();
  }

  listarClientesComPacote() {
    this.orcamentoService.listarClientesComPacotePorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: ClienteResumo[]) => {
        this.clientesComPacote = data;
        this.clientesComPacote.unshift({nome: 'TODOS'})
        
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  onLazyLoad(event: LazyLoadEvent) {
      if(event.first !== undefined && event.rows !== undefined) {
        if (event.first === 0 && event.rows === 0) {
          this.numeroPagina = 0;
        } else {
          this.numeroPagina = event.first / event.rows;
        }
      }
      if (event.sortField && event.sortOrder) {
        this.definirOrdenacao(event.sortField, event.sortOrder);
      }
      
      this.listarPacotesCliente();
    }
  
    definirOrdenacao(sortField: string, sortOrder: number) {
      const campoDeOrdenacao = sortField ? sortField : 'dataOrcamento';
      const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
      this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
    }

  carregarCliente() {
    this.clienteService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: Cliente) => {
        this.clienteSelecionado = data;
        this.listarPacotesCliente();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  listarPacotesCliente() {
    this.loading = true;
    this.orcamentoService.listarPacotePorEmpresaEClientePaginado(this.getEmpresa().id, this.clienteSelecionado?.id,
      this.statusPacoteSelecionado, this.numeroPagina, this.tamanhoPagina, this.ordenacao, this.inputBusca).subscribe({
      next: (data: Paginador<Orcamento>) => {
        this.itensPaginados = data;
        this.listaPacotes = data.content;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  recarregarDados(table: Table) {
    table.clear();
  }


  buscar(event: Event, table: Table) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    table.clear();
  }

  limpar(table: Table) {
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.statusPacoteSelecionado = 'TODOS';
    this.clienteSelecionado = {nome: 'TODOS'};
    table.reset();
  }

}
